import { combineReducers } from "redux";
import { documentPreviewConstants } from "../actions/documentPreview";

function documents(state, { type, payload }) {
  let defaultState = typeof state === "undefined" ? null : state;
  switch (type) {
  case documentPreviewConstants.GET_PREVIEW_DOCUMENT_DETAIL_SUCCESS:
    let docId = payload.documentId;
    return { ...defaultState, [docId]: { ...payload } };
  case documentPreviewConstants.GET_PREVIEW_DOCUMENT_SUCCESS:
    let docIdSel = payload.documentId;
    return { ...defaultState, [docIdSel]: {  ...defaultState[docIdSel], content: payload.content } };
  default:
    return defaultState;
  }
}

function preview(state, { type, payload }) {
  let defaultState = typeof state === "undefined" ? null : state;
  switch (type) {
  case documentPreviewConstants.GET_PREVIEW_DOCUMENT_SUCCESS:
    return payload.content;
  case documentPreviewConstants.GET_PREVIEW_DOCUMENT_START: {
    return null;
  }
  default:
    return defaultState;
  }
}

function isLoadingPreview(state, { type }) {
  let defaultState = typeof state === "undefined" ? false : state;
  switch (type) {
  case documentPreviewConstants.GET_PREVIEW_DOCUMENT_START:  
    return true;
  case documentPreviewConstants.GET_PREVIEW_DOCUMENT_SUCCESS:
  case documentPreviewConstants.GET_PREVIEW_DOCUMENT_ERROR:
    return false;
  default:
    return defaultState;
  }
}

function isLoadingDocument(state, { type }) {
  let defaultState = typeof state === "undefined" ? false : state;
  switch (type) {
  case documentPreviewConstants.GET_PREVIEW_DOCUMENT_DETAIL_START:
  case documentPreviewConstants.GET_PREVIEW_DOCUMENT_START:
    return true;
  case documentPreviewConstants.GET_PREVIEW_DOCUMENT_DETAIL_SUCCESS:
  case documentPreviewConstants.GET_PREVIEW_DOCUMENT_DETAIL_ERROR:
  case documentPreviewConstants.GET_PREVIEW_DOCUMENT_SUCCESS:      
    return false;
  default:
    return defaultState;
  }
}

export const documentPreview = combineReducers({
  documents,
  preview,
  isLoadingPreview,
  isLoadingDocument
});

export default documentPreview;
